import { FirestoreDataConverter } from "firebase/firestore";
import BaseDb from "./baseDb";
import Credito from "../models/credito";
import toFirestore from "./toFirestore";

export default class CreditoDb extends BaseDb<Credito, { creditoId: string }> {
  _path: string = "creditos/creditoId";
  getConverter(): FirestoreDataConverter<Credito> {
    return {
      fromFirestore: (snapshot, _options) => {
        return new Credito({
          saldo: snapshot.get("saldo"),
        });
      },
      toFirestore: toFirestore,
    };
  }
}
